import graphql__bc0cbda81cd2ffb49981 from "./__generated__/EnrollTwoFactorPhoneMutation.graphql.js";import { commitMutation, graphql } from "react-relay";
import mapValues from "lodash/mapValues";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__bc0cbda81cd2ffb49981;

async function enrollTwoFactorPhone(form) {
  const variables = mapValues(form.fields, field => field.value);

  return new Promise((resolve, reject) => {
    commitMutation(appRelayEnvironment, {
      mutation,
      variables,
      onCompleted: (response, errors) => {
        if (errors) {
          reject(errors);
        } else {
          resolve(response);
        }
      },
      onError: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}

export { enrollTwoFactorPhone };
